import React, { Fragment, useEffect } from 'react'
import { Container, Card, Col, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { Link,useNavigate } from 'react-router-dom'
import { getRestaurants } from '../../actions/restaurantsActions'

export default function TakeRestaurant() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const {client} = useAuth()

    const {restaurants} = useSelector(state=>state.restaurants)

	useEffect(() => {
		if(client){
			if(client?.rol==='Admin'){
				dispatch(getRestaurants())
			}else{
				navigate('/kitchen/dashboard')
			}
		}
	},[dispatch, t, client])

	return (
		<Container className='p-5'>	
			<Row className="mb-3">
				<Col xs={2} className='p-0'>
					<Link className="p-0 my-3" to="/kitchen/dashboard">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
					</Link>
				</Col>
				<Col xs={8} className='text-center'>
					<h1 className='fs-18'>{t('kitchen.takeorder.title')}</h1>
				</Col>
				<Col xs={2}></Col>
			</Row>
			<Row className="mt-5">
				<span className="sd-label-medium">{t('kitchen.takeorder.restaurantsnow')}</span>
			</Row>
			<Row className="my-3">
				<Col>
					{restaurants?.map((restaurant, index) => (
						<Fragment key={index}>
							<Link className="p-0 my-3" to={`/kitchen/ordersdashboard/${restaurant._id}`}>
								<Card className="card-restaurants my-3" style={{ backgroundImage: `url('${restaurant.photo}')`, backgroundSize: '100%', backgroundRepeat: 'no-repeat'}}>
									<div className="cardbody-restaurants">
										<label className="sd-label-medium fs-18 fw-600">{restaurant.name}</label><br/>
										<label className="sd-label-medium fs-16 fw-600">{t('kitchen.takeorder.restaurantsopen')}:</label>
											{restaurant?.schedule?.monday?.scheduleopen !== '00:00' || restaurant?.schedule?.monday?.scheduleclose !== '00:00' ? t('admin.restaurants.monday')+': '+restaurant?.schedule?.monday?.scheduleopen+' - '+restaurant?.schedule?.monday?.scheduleclose+'\n': ''}
											{restaurant?.schedule?.tuesday?.scheduleopen !== '00:00' || restaurant?.schedule?.tuesday?.scheduleclose !== '00:00' ? t('admin.restaurants.tuesday')+': '+restaurant?.schedule?.tuesday?.scheduleopen+' - '+restaurant?.schedule?.tuesday?.scheduleclose+'\n': ''}
											{restaurant?.schedule?.wednesday?.scheduleopen !== '00:00' || restaurant?.schedule?.wednesday?.scheduleclose !== '00:00' ? t('admin.restaurants.wednesday')+': '+restaurant?.schedule?.wednesday?.scheduleopen+' - '+restaurant?.schedule?.wednesday?.scheduleclose+'\n': ''}
											{restaurant?.schedule?.thursday?.scheduleopen !== '00:00' || restaurant?.schedule?.thursday?.scheduleclose !== '00:00' ? t('admin.restaurants.thursday')+': '+restaurant?.schedule?.thursday?.scheduleopen+' - '+restaurant?.schedule?.thursday?.scheduleclose+'\n': ''}
											{restaurant?.schedule?.friday?.scheduleopen !== '00:00' || restaurant?.schedule?.friday?.scheduleclose !== '00:00' ? t('admin.restaurants.friday')+': '+restaurant?.schedule?.friday?.scheduleopen+' - '+restaurant?.schedule?.friday?.scheduleclose+'\n': ''}
											{restaurant?.schedule?.saturday?.scheduleopen !== '00:00' || restaurant?.schedule?.saturday?.scheduleclose !== '00:00' ? t('admin.restaurants.saturday')+': '+restaurant?.schedule?.saturday?.scheduleopen+' - '+restaurant?.schedule?.saturday?.scheduleclose+'\n': ''}
											{restaurant?.schedule?.sunday?.scheduleopen !== '00:00' || restaurant?.schedule?.sunday?.scheduleclose !== '00:00' ? t('admin.restaurants.sunday')+': '+restaurant?.schedule?.sunday?.scheduleopen+' - '+restaurant?.schedule?.sunday?.scheduleclose+'\n': ''}
										<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fillRule="evenodd" clipRule="evenodd" d="M5.51307 13.5944C5.53431 13.6062 5.55101 13.6153 5.56283 13.6217L5.58246 13.6323C5.73918 13.715 5.93359 13.7144 6.09046 13.6325L6.11061 13.6217C6.12244 13.6153 6.13913 13.6062 6.16037 13.5944C6.20285 13.5707 6.26354 13.5362 6.33986 13.491C6.49243 13.4006 6.70781 13.2674 6.96508 13.0926C7.47875 12.7436 8.16413 12.2258 8.85101 11.5494C10.2181 10.2032 11.6381 8.18064 11.6381 5.57948C11.6381 2.49802 9.04074 0 5.83672 0C2.63271 0 0.0353394 2.49802 0.0353394 5.57948C0.0353394 8.18064 1.45532 10.2032 2.82243 11.5494C3.50931 12.2258 4.19469 12.7436 4.70836 13.0926C4.96563 13.2674 5.18101 13.4006 5.33358 13.491C5.4099 13.5362 5.4706 13.5707 5.51307 13.5944ZM5.83672 7.60839C7.00182 7.60839 7.94631 6.70002 7.94631 5.57948C7.94631 4.45895 7.00182 3.55058 5.83672 3.55058C4.67162 3.55058 3.72713 4.45895 3.72713 5.57948C3.72713 6.70002 4.67162 7.60839 5.83672 7.60839Z" fill="#0F172A"/>
										</svg>&nbsp;
										<label className="fs-16 fw-400">{restaurant.address}</label>
										<svg className="float-end mt-1" width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1.57751 9L15.3647 9" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
											<path d="M8.47119 2L15.3648 9L8.47119 16" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
										</svg>
									</div>
								</Card>
							</Link>
						</Fragment>
					))}
				</Col>
			</Row>
		</Container>
	)
}